export const KEYS = {
	KEY_BUSINESS_USER_TOKEN: 'business-user-token'
}
